import { render, staticRenderFns } from "./nl.vue?vue&type=template&id=19ada594&scoped=true&lang=html&"
import script from "./nl.vue?vue&type=script&lang=js&"
export * from "./nl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ada594",
  null
  
)

export default component.exports